<script>
export default {
  data() {
    return {
      title: "Providers",
      text: "Providers",
    };
  },
  methods: {
    submitForm() {
      this.$router.push("/service-provider/providers");
    },
  },
};
</script>
<template>
  <layout-header></layout-header>
  <services-breadcrumb :title="title" :text="text" />
  <div class="page-wrapper">
    <div class="content content-two">
      <div class="container">
        <div class="row align-items-start">
          <div class="col-xl-3 col-lg-4 stickysidebar">
            <div class="card">
              <div class="card-body">
                <form @submit.prevent="submitForm">
                  <div
                    class="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom"
                  >
                    <h5><i class="ti ti-filter-check me-2"></i>Filters</h5>
                    <a href="javascript:void(0);">Reset Filter</a>
                  </div>
                  <div class="mb-3 pb-3 border-bottom">
                    <label class="form-label">Search By Keyword</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="What are you looking for?"
                    />
                  </div>
                  <div class="accordion">
                    <div class="accordion-item mb-3">
                      <div class="accordion-header" id="accordion-headingThree">
                        <div
                          class="accordion-button p-0 mb-3"
                          data-bs-toggle="collapse"
                          data-bs-target="#accordion-collapseThree"
                          aria-expanded="true"
                          aria-controls="accordion-collapseThree"
                          role="button"
                        >
                          Categories
                        </div>
                      </div>
                      <div
                        id="accordion-collapseThree"
                        class="accordion-collapse collapse show"
                        aria-labelledby="accordion-headingThree"
                      >
                        <div class="mb-3">
                          <div class="form-check mb-2">
                            <label class="form-check-label">
                              <input class="form-check-input" type="checkbox" checked />
                              All Categories
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <label class="form-check-label">
                              <input class="form-check-input" type="checkbox" />
                              Construction
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <label class="form-check-label">
                              <input class="form-check-input" type="checkbox" />
                              Car Wash
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <label class="form-check-label">
                              <input class="form-check-input" type="checkbox" />
                              Electrical
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <label class="form-check-label">
                              <input class="form-check-input" type="checkbox" />
                              Cleaning
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="accordion border-bottom mb-3">
                    <div class="accordion-header" id="accordion-headingFour">
                      <div
                        class="accordion-button p-0 mb-3"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordion-collapseFour"
                        aria-expanded="true"
                        aria-controls="accordion-collapseFour"
                        role="button"
                      >
                        Price Range
                      </div>
                    </div>
                    <div
                      id="accordion-collapseFour"
                      class="accordion-collapse collapse show"
                      aria-labelledby="accordion-headingFour"
                    >
                      <div class="row gx-2">
                        <div class="col-6">
                          <div class="mb-3">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="$ Min"
                            />
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="mb-3">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="$ Max"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="accordion border-bottom mb-3">
                    <div class="accordion-header" id="accordion-headingFive">
                      <div
                        class="accordion-button p-0 mb-3"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordion-collapseFive"
                        aria-expanded="true"
                        aria-controls="accordion-collapseFive"
                        role="button"
                      >
                        Location
                      </div>
                    </div>
                    <div
                      id="accordion-collapseFive"
                      class="accordion-collapse collapse show"
                      aria-labelledby="accordion-headingFive"
                    >
                      <div class="mb-3">
                        <div class="position-relative">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Select Location"
                          />
                          <span class="icon-addon"><i class="ti ti-map-pin"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="accordion">
                    <div class="accordion-item mb-3">
                      <div class="accordion-header" id="accordion-headingTwo">
                        <div
                          class="accordion-button fs-18 p-0 mb-3"
                          data-bs-toggle="collapse"
                          data-bs-target="#accordion-collapseTwo"
                          aria-expanded="true"
                          aria-controls="accordion-collapseTwo"
                          role="button"
                        >
                          Ratings
                        </div>
                      </div>
                      <div
                        id="accordion-collapseTwo"
                        class="accordion-collapse collapse show"
                        aria-labelledby="accordion-headingTwo"
                      >
                        <div class="mb-3">
                          <div class="form-check mb-2">
                            <label class="form-check-label d-block">
                              <input class="form-check-input" type="checkbox" checked />
                              <span class="rating">
                                <i class="fas fa-star filled me-1"></i>
                                <i class="fas fa-star filled me-1"></i>
                                <i class="fas fa-star filled me-1"></i>
                                <i class="fas fa-star filled me-1"></i>
                                <i class="fas fa-star filled me-1"></i
                                ><span class="float-end">(55)</span>
                              </span>
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <label class="form-check-label d-block">
                              <input class="form-check-input" type="checkbox" />
                              <span class="rating">
                                <i class="fas fa-star filled me-1"></i>
                                <i class="fas fa-star filled me-1"></i>
                                <i class="fas fa-star filled me-1"></i>
                                <i class="fas fa-star filled me-1"></i>
                                <i class="fa-regular fa-star filled"></i
                                ><span class="float-end">(48)</span>
                              </span>
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <label class="form-check-label d-block">
                              <input class="form-check-input" type="checkbox" />
                              <span class="rating">
                                <i class="fas fa-star filled me-1"></i>
                                <i class="fas fa-star filled me-1"></i>
                                <i class="fas fa-star filled me-1"></i>
                                <i class="fa-regular fa-star filled"></i>
                                <i class="fa-regular fa-star filled"></i
                                ><span class="float-end">(13)</span>
                              </span>
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <label class="form-check-label d-block">
                              <input class="form-check-input" type="checkbox" />
                              <span class="rating">
                                <i class="fas fa-star filled me-1"></i>
                                <i class="fas fa-star filled me-1"></i>
                                <i class="fa-regular fa-star filled"></i>
                                <i class="fa-regular fa-star filled"></i>
                                <i class="fa-regular fa-star filled"></i
                                ><span class="float-end">(05)</span>
                              </span>
                            </label>
                          </div>
                          <div class="form-check mb-2">
                            <label class="form-check-label d-block">
                              <input class="form-check-input" type="checkbox" />
                              <span class="rating">
                                <i class="fas fa-star filled me-1"></i>
                                <i class="fa-regular fa-star filled"></i>
                                <i class="fa-regular fa-star filled"></i>
                                <i class="fa-regular fa-star filled"></i>
                                <i class="fa-regular fa-star filled"></i
                                ><span class="float-end">(00)</span>
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button type="submit" class="btn btn-dark w-100">Search</button>
                </form>
              </div>
            </div>
          </div>
          <div class="col-xl-9 col-lg-8">
            <div class="row">
              <div class="col-xl-4 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="card-img card-img-hover mb-3">
                      <router-link to="/service-provider/provider-details"
                        ><img src="@/assets/img/providers/provider-01.jpg" alt="Img"
                      /></router-link>
                    </div>
                    <div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <h5 class="d-flex align-items-center mb-1">
                            <router-link to="/service-provider/provider-details">Michael</router-link
                            ><span class="text-success ms-2"
                              ><i class="fa fa-check-circle"></i
                            ></span>
                          </h5>
                          <span>Carpenter</span>
                        </div>
                        <p class="fs-18 fw-medium text-dark">
                          $50.00<span class="fw-normal fs-13 text-default">/hr</span>
                        </p>
                      </div>
                      <div class="rating">
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fa-solid fa-star-half-stroke filled"></i
                        ><span class="ms-2 d-inline-block">(320)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="card-img card-img-hover mb-3">
                      <router-link to="/service-provider/provider-details"
                        ><img src="@/assets/img/providers/provider-02.jpg" alt="Img"
                      /></router-link>
                    </div>
                    <div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <h5 class="d-flex align-items-center mb-1">
                            <router-link to="/service-provider/provider-details">Antoinette</router-link
                            ><span class="text-success ms-2"
                              ><i class="fa fa-check-circle"></i
                            ></span>
                          </h5>
                          <span>Cleaner</span>
                        </div>
                        <p class="fs-18 fw-medium text-dark">
                          $25.00<span class="fw-normal fs-13 text-default">/hr</span>
                        </p>
                      </div>
                      <div class="rating">
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fa-solid fa-star-half-stroke filled"></i
                        ><span class="ms-2 d-inline-block">(120)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="card-img card-img-hover mb-3">
                      <router-link to="/service-provider/provider-details"
                        ><img src="@/assets/img/providers/provider-03.jpg" alt="Img"
                      /></router-link>
                    </div>
                    <div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <h5 class="d-flex align-items-center mb-1">
                            <router-link to="/service-provider/provider-details">Thompson</router-link
                            ><span class="text-success ms-2"
                              ><i class="fa fa-check-circle"></i
                            ></span>
                          </h5>
                          <span>Mechanic</span>
                        </div>
                        <p class="fs-18 fw-medium text-dark">
                          $30.00<span class="fw-normal fs-13 text-default">/hr</span>
                        </p>
                      </div>
                      <div class="rating">
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fa-solid fa-star-half-stroke filled"></i
                        ><span class="ms-2 d-inline-block">(95)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="card-img card-img-hover mb-3">
                      <router-link to="/service-provider/provider-details"
                        ><img src="@/assets/img/providers/provider-04.jpg" alt="Img"
                      /></router-link>
                    </div>
                    <div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <h5 class="d-flex align-items-center mb-1">
                            <router-link to="/service-provider/provider-details">Lawrence</router-link
                            ><span class="text-success ms-2"
                              ><i class="fa fa-check-circle"></i
                            ></span>
                          </h5>
                          <span>Engineer</span>
                        </div>
                        <p class="fs-18 fw-medium text-dark">
                          $70.00<span class="fw-normal fs-13 text-default">/hr</span>
                        </p>
                      </div>
                      <div class="rating">
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fa-solid fa-star-half-stroke filled"></i
                        ><span class="ms-2 d-inline-block">(228)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="card-img card-img-hover mb-3">
                      <router-link to="/service-provider/provider-details"
                        ><img src="@/assets/img/providers/provider-05.jpg" alt="Img"
                      /></router-link>
                    </div>
                    <div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <h5 class="d-flex align-items-center mb-1">
                            <router-link to="/service-provider/provider-details">Ellen</router-link
                            ><span class="text-success ms-2"
                              ><i class="fa fa-check-circle"></i
                            ></span>
                          </h5>
                          <span>Designer</span>
                        </div>
                        <p class="fs-18 fw-medium text-dark">
                          $30.00<span class="fw-normal fs-13 text-default">/hr</span>
                        </p>
                      </div>
                      <div class="rating">
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fa-solid fa-star-half-stroke filled"></i
                        ><span class="ms-2 d-inline-block">(130)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="card-img card-img-hover mb-3">
                      <router-link to="/service-provider/provider-details"
                        ><img src="@/assets/img/providers/provider-06.jpg" alt="Img"
                      /></router-link>
                    </div>
                    <div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <h5 class="d-flex align-items-center mb-1">
                            <router-link to="/service-provider/provider-details">Nathaniel</router-link
                            ><span class="text-success ms-2"
                              ><i class="fa fa-check-circle"></i
                            ></span>
                          </h5>
                          <span>Plumber</span>
                        </div>
                        <p class="fs-18 fw-medium text-dark">
                          $45.00<span class="fw-normal fs-13 text-default">/hr</span>
                        </p>
                      </div>
                      <div class="rating">
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fa-solid fa-star-half-stroke filled"></i
                        ><span class="ms-2 d-inline-block">(95)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="card-img card-img-hover mb-3">
                      <router-link to="/service-provider/provider-details"
                        ><img src="@/assets/img/providers/provider-07.jpg" alt="Img"
                      /></router-link>
                    </div>
                    <div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <h5 class="d-flex align-items-center mb-1">
                            <router-link to="/service-provider/provider-details">Stephanie</router-link
                            ><span class="text-success ms-2"
                              ><i class="fa fa-check-circle"></i
                            ></span>
                          </h5>
                          <span>Carpenter</span>
                        </div>
                        <p class="fs-18 fw-medium text-dark">
                          $40.00<span class="fw-normal fs-13 text-default">/hr</span>
                        </p>
                      </div>
                      <div class="rating">
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fa-solid fa-star-half-stroke filled"></i
                        ><span class="ms-2 d-inline-block">(228)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="card-img card-img-hover mb-3">
                      <router-link to="/service-provider/provider-details"
                        ><img src="@/assets/img/providers/provider-08.jpg" alt="Img"
                      /></router-link>
                    </div>
                    <div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <h5 class="d-flex align-items-center mb-1">
                            <router-link to="/service-provider/provider-details">Charles</router-link
                            ><span class="text-success ms-2"
                              ><i class="fa fa-check-circle"></i
                            ></span>
                          </h5>
                          <span>Serviceman</span>
                        </div>
                        <p class="fs-18 fw-medium text-dark">
                          $55.00<span class="fw-normal fs-13 text-default">/hr</span>
                        </p>
                      </div>
                      <div class="rating">
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fa-solid fa-star-half-stroke filled"></i
                        ><span class="ms-2 d-inline-block">(130)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="card-img card-img-hover mb-3">
                      <router-link to="/service-provider/provider-details"
                        ><img src="@/assets/img/providers/provider-09.jpg" alt="Img"
                      /></router-link>
                    </div>
                    <div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <h5 class="d-flex align-items-center mb-1">
                            <router-link to="/service-provider/provider-details">George</router-link
                            ><span class="text-success ms-2"
                              ><i class="fa fa-check-circle"></i
                            ></span>
                          </h5>
                          <span>Mechanic</span>
                        </div>
                        <p class="fs-18 fw-medium text-dark">
                          $70.00<span class="fw-normal fs-13 text-default">/hr</span>
                        </p>
                      </div>
                      <div class="rating">
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fa-solid fa-star-half-stroke filled"></i
                        ><span class="ms-2 d-inline-block">(95)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="card-img card-img-hover mb-3">
                      <router-link to="/service-provider/provider-details"
                        ><img src="@/assets/img/providers/provider-10.jpg" alt="Img"
                      /></router-link>
                    </div>
                    <div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <h5 class="d-flex align-items-center mb-1">
                            <router-link to="/service-provider/provider-details">Nicholas</router-link
                            ><span class="text-success ms-2"
                              ><i class="fa fa-check-circle"></i
                            ></span>
                          </h5>
                          <span>Electrician</span>
                        </div>
                        <p class="fs-18 fw-medium text-dark">
                          $20.00<span class="fw-normal fs-13 text-default">/hr</span>
                        </p>
                      </div>
                      <div class="rating">
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fa-solid fa-star-half-stroke filled"></i
                        ><span class="ms-2 d-inline-block">(320)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="card-img card-img-hover mb-3">
                      <router-link to="/service-provider/provider-details"
                        ><img src="@/assets/img/providers/provider-11.jpg" alt="Img"
                      /></router-link>
                    </div>
                    <div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <h5 class="d-flex align-items-center mb-1">
                            <router-link to="/service-provider/provider-details">Gloria</router-link
                            ><span class="text-success ms-2"
                              ><i class="fa fa-check-circle"></i
                            ></span>
                          </h5>
                          <span>Cleaner</span>
                        </div>
                        <p class="fs-18 fw-medium text-dark">
                          $30.00<span class="fw-normal fs-13 text-default">/hr</span>
                        </p>
                      </div>
                      <div class="rating">
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fa-solid fa-star-half-stroke filled"></i
                        ><span class="ms-2 d-inline-block">(420)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="card-img card-img-hover mb-3">
                      <router-link to="/service-provider/provider-details"
                        ><img src="@/assets/img/providers/provider-12.jpg" alt="Img"
                      /></router-link>
                    </div>
                    <div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <h5 class="d-flex align-items-center mb-1">
                            <router-link to="/service-provider/provider-details">John Smith</router-link
                            ><span class="text-success ms-2"
                              ><i class="fa fa-check-circle"></i
                            ></span>
                          </h5>
                          <span>Electrician</span>
                        </div>
                        <p class="fs-18 fw-medium text-dark">
                          $20.00<span class="fw-normal fs-13 text-default">/hr</span>
                        </p>
                      </div>
                      <div class="rating">
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fa-solid fa-star-half-stroke filled"></i
                        ><span class="ms-2 d-inline-block">(320)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <pages-footer></pages-footer>
</template>
